<template>
  <div>
    <div class="row">
      <div class="col-xs-6 col-xs-offset-3">
        <HeadFromModel
          @leaderTypeSelection="select"
          style="width: 80%; margin: 0 auto"
          :kind="KIND"
          :headId="reviewId"
        />
      </div>
    </div>
    <div style="height: 40px"></div>

    <div class="form-horizontal tab-content infoBox">
      <div class="text-center" v-if="!tab" role="tabpanel">
        <p class="h4" v-if="doc">Click on a square to be reminded of the question.</p>
        <p class="h4" v-else>Loading...</p>
      </div>

      <div class="row" v-else :key="selected" role="tabpanel">
        <div class="col-sm-10 col-sm-offset-1 text-center">
          <h4>{{ tab.title }}</h4>
          <div v-html="tab.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import cms from "../../services/cms/cms";
import { CmsTeamEffectivenessReview } from "../../services/cms/cms-type-definitions";
import cmsContentMap from "../../services/cms/cms-content-map";
import HeadFromModel from "./head-from-model.vue";

const props = withDefaults(
  defineProps<{
    reviewId: string | null;
  }>(),
  {
    reviewId: null,
  },
);

const KIND = "TeamEffectivenessAggregateDiamond";

const doc = ref<CmsTeamEffectivenessReview | null>(null);

const selected = ref("");

function select(leaderType: string): void {
  selected.value = leaderType;
}

const tab = computed(() => {
  if (!doc.value) {
    return null;
  }

  const data = doc.value.data.body.find((s) => s.primary.question_id === selected.value)?.primary;

  if (!data) {
    return null;
  }

  return {
    title: cms.asText(data.question_title),
    content: cms.asHtml(data?.question_panel_text),
  };
});

onMounted(() => {
  cms
    .getByUid("cms-team-effectiveness-review", cmsContentMap.teamEffectiveness.questionnaireUid)
    .then((d) => {
      doc.value = d;
    });
});
</script>
